/**
 * Image - Simple image component with responsive behavior
 * Handles both regular images and background images
 */

import React from 'react'
import { CardMedia, Box } from '@mui/material'

interface ImageProps {
	src: string
	alt: string
	width?: number | string
	height?: number | string
	fit?: 'cover' | 'contain' | 'fill'
	rounded?: boolean
	centered?: boolean
}

const Image: React.FC<ImageProps> = ({ src, alt, width = 'auto', height = 'auto', fit = 'cover', rounded = false, centered = false }) => {
	return (
		<Box
			sx={{
				display: centered ? 'flex' : 'block',
				justifyContent: centered ? 'center' : 'flex-start',
				alignItems: centered ? 'center' : 'flex-start'
			}}
		>
			<CardMedia
				component="img"
				image={src}
				alt={alt}
				sx={{
					width: width,
					height: height,
					objectFit: fit,
					borderRadius: rounded ? 1 : 0,
					maxWidth: '100%'
				}}
			/>
		</Box>
	)
}

export default Image
